import React, { useState, useEffect } from "react";
import {
  Modal,
  Alert,
  Checkbox,
  Form,
  Input,
  Radio,
  Card,
  Divider,
  Steps,
  Select,
  Tag,
  Image,
  Row,
  Col,
  List,
  Avatar,
  DatePicker,
  Dropdown,
  Button,
  Menu,
  Typography,
  Space,
  Badge,
} from "antd";
import "./ProductBooking.css";
import { SearchOutlined } from "@ant-design/icons";
import moment from "moment";
import axios from "axios";
import { observer } from "mobx-react-lite";
import { useNavigate, useLocation } from "react-router-dom";

import { useAuth } from "../../../layouts/auth/AuthContext";
import { mstBooking, mstGeneral } from "../../../mobx";
import Navbar from "../../../layouts/navbar";
import { useProduct } from "./ProductContext";
import Paragraph from "antd/lib/typography/Paragraph";
import { useCart } from "../../../layouts/cart/CartContext";
import { useReferral } from "../../../utils/referral";
import Footer from "../../../layouts/footer";

const { Text, Link, Title } = Typography;
const { RangePicker } = DatePicker;
const { Option } = Select;
const { Step } = Steps;
const { TextArea } = Input;

const ProductList = observer((props: any) => {
  const { products, fetchProducts, onCurrentBooking, addToCart } = useProduct();
  const { user } = useAuth();
  const { navigateWithReferral } = useReferral();
  const navProps = useLocation();
  const [currentStep, setCurrentStep] = useState(1);
  const [paymentStatus, setPaymentStatus] = useState("success");
  const [rooms, setRooms] = useState([]);

  const [checkoutDate, setCheckoutDate] = useState("");

  const [roomQty, setRoomQty] = useState(1);
  const [searchDropdownVisible, setSearchDropdownVisible] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [searching, setSearching] = useState(false);
  const [payingNow, setPayingNow] = useState(false);
  const [loginAlertVisible, setLoginAlertVisible] = useState(false);
  const [filled, setFilled] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [priceType, setPriceType] = useState(0);
  const [specialRequest, setSpecialRequest] = useState("");
  const [checkedAddons, setCheckedAddons] = useState([]);
  const [checkedAddonDetails, setCheckedAddonDetails] = useState([]);
  const [openDatepicker, setOpenDatepicker] = useState(false);
  const [visibleDropdown, setVisibleDropdown] = useState(false);

  const [selectedRestaurant, setSelectedRestaurant] = useState<any>(null);
  const [adultPax, setAdultPax] = useState(2);
  const [childPax, setChildPax] = useState(0);
  const [checkinDate, setCheckinDate] = useState("");

  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [selectedPrice, setSelectedPrice] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);

  const truncate = (str: any, n: any) => {
    if (!str) return "";
    return str.length > n ? str.substring(0, n) + "..." : str;
  };

  const handleOpen = (product: any) => {
    setSelectedProduct(product);
    setSelectedPrice(null);
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
    setSelectedProduct(null);
    setSelectedPrice(null);
  };

  const onOpenDatepicker = () => {
    console.log("onOpenDatepicker");
    setOpenDatepicker(true);
  };

  const onChangeDate = (date: any) => {
    console.log("onChangeDate");
    setCheckinDate(date);
    setOpenDatepicker(false);
  };

  const onOpenChange = () => {
    console.log("onOpenChange");
    setOpenDatepicker(!openDatepicker);
  };

  const onSelectRestaurant = (value: any) => {
    setSelectedRestaurant(value);
  };

  const onVisibleDropdown = () => {
    setVisibleDropdown(!visibleDropdown);
  };

  const onAutofillForm = (checked: any) => {
    console.log("check onAutofillForm ===> ", checked);
    if (checked) {
      setFilled(checked);
      setName(
        `${user?.firstname !== undefined ? user?.firstname : ""}${
          user?.lastname !== undefined ? " " + user?.lastname : ""
        }`
      );
      setEmail(`${user?.email !== undefined ? user?.email : ""}`);
      setPhone(`${user?.phone !== undefined ? user?.phone : ""}`);
    } else {
      setFilled(checked);
      setName("");
      setEmail("");
      setPhone("");
    }
  };

  const onPayNow = () => {
    setPayingNow(true);
    const params = {
      UUID: user?.UUID,
      Price_type: priceType,
      checkin_date: checkinDate,
      checkout_date: checkoutDate,
      adult_pax: adultPax,
      child_pax: childPax,
      room_qty: roomQty,
      Booking_Name: name,
      Booking_Email: email,
      Booking_Phone: phone,
      SpecialRequest: specialRequest,
    };
    const addonParams = [...checkedAddonDetails];
    mstBooking
      .createBooking(params, addonParams)
      .then((response) => {
        mstBooking
          .createPayment({
            UUID: user?.UUID,
            order_number: response.order_number,
            paytype: 0,
          })
          .then((response) => {
            console.log(
              "Check response createPayment at home.js ===> ",
              response
            );
            window.location.replace(response);
          })
          .catch((error) => {
            console.log("Check error createPayment at home.js ===> ", error);
            setPayingNow(false);
          });
      })
      .catch((error) => {
        console.log("Check response createBooking at home.js ===> ", error);
        setPayingNow(false);
      });
  };

  const onChangeQuantity = (type: any, action: any) => {
    const adultMax = 20;
    const childMax = 20;
    const roomMax = 20;

    if (type === "adultPax") {
      if (action === "minus") {
        if (adultPax > 0) {
          setAdultPax(adultPax - 1);
        } else {
          console.log("Already reached minimum");
        }
      } else if (action === "add") {
        if (adultPax < adultMax) {
          setAdultPax(adultPax + 1);
        } else {
          console.log("Already reached maximum");
        }
      }
    } else if (type === "childPax") {
      if (action === "minus") {
        if (childPax > 0) {
          setChildPax(childPax - 1);
        } else {
          console.log("Already reached minimum");
        }
      } else if (action === "add") {
        if (childPax < childMax) {
          setChildPax(childPax + 1);
        } else {
          console.log("Already reached maximum");
        }
      }
    } else if (type === "roomQty") {
      if (action === "minus") {
        if (roomQty > 0) {
          setRoomQty(roomQty - 1);
        } else {
          console.log("Already reached minimum");
        }
      } else if (action === "add") {
        if (roomQty < roomMax) {
          setRoomQty(roomQty + 1);
        } else {
          console.log("Already reached maximum");
        }
      }
    }
  };

  const onSearch = async () => {
    setSearching(true);
    await fetchProducts({
      // @ts-ignore
      store_id: "",
      // store_id: selectedRestaurant?.store_id
      //   ? parseInt(selectedRestaurant.store_id)
      //   : undefined,
      search: "",
    });
    setSearching(false);
  };

  const [restaurantListModalVisible, setRestaurantListModalVisible] =
    useState(false);
  const [restaurants, setRestaurants] = useState([]);

  const loadRestaurants = () => {
    mstGeneral
      .fetchRestaurants()
      .then((response: any) => {
        setRestaurants(response);
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  useEffect(() => {
    loadRestaurants();
    onSearch();
  }, []);

  const menu = (
    <Menu style={{ padding: "1em" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1em",
        }}
      >
        <Text style={{ fontSize: 16 }}>Adult</Text>
        <div>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginRight: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("adultPax", "minus");
            }}
          >
            -
          </Button>
          <Text style={{ fontSize: 16 }}>
            <b>{adultPax}</b>
          </Text>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginLeft: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("adultPax", "add");
            }}
          >
            +
          </Button>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1em",
        }}
      >
        <Text style={{ fontSize: 16 }}>Child</Text>
        <div>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginRight: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("childPax", "minus");
            }}
          >
            -
          </Button>
          <Text style={{ fontSize: 16 }}>
            <b>{childPax}</b>
          </Text>
          <Button
            type="link"
            style={{
              fontSize: 20,
              marginLeft: "1em",
              marginTop: 0,
              padding: "0em",
            }}
            onClick={(e) => {
              onChangeQuantity("childPax", "add");
            }}
          >
            +
          </Button>
        </div>
      </div>
    </Menu>
  );

  let prices = [];
  for (let i = 0; i < roomQty; i++) {
    prices.push({ value: i + 1 });
  }

  const renderStatus = (status: any) => {
    return status === "1" ? (
      <Tag color="green">Open</Tag>
    ) : (
      <Tag color="red">Closed</Tag>
    );
  };

  // Updated function to handle product variations
  const getProductVariants = (product: any) => {
    // If product has variations, convert them to price_cat format
    if (product.variations && product.variations.length > 0) {
      const variants: any[] = [];
      product.variations.forEach((variation: any) => {
        variation.options.forEach((option: any) => {
          variants.push({
            price_id: option.id,
            title: `${variation.title} - ${option.title}`,
            amount: option.price,
            quantity: 1,
          });
        });
      });
      return variants;
    }

    // If no variations, create a default price option
    return [
      {
        price_id: product.product_id,
        title: "Standard",
        amount: product.price,
        quantity: 1,
      },
    ];
  };

  // const onAddToCart = (product: any, selectedOption: any, quantity = 1) => {
  //   if (!selectedRestaurant) {
  //     alert("Please select a restaurant first");
  //     return;
  //   }

  //   const newItem = {
  //     product_name: product.name, // Changed from product.title to product.name
  //     product_id: product.product_id,
  //     store_name: selectedRestaurant.name,
  //     store_id: selectedRestaurant.store_id,
  //     variant: {
  //       price_id: selectedOption.price_id,
  //       title: selectedOption.title,
  //       amount: selectedOption.amount,
  //       quantity: quantity,
  //     },
  //   };

  //   addToCart(newItem);
  //   console.log("Product added to cart:", newItem);

  //   // Show success message
  //   Modal.success({
  //     title: "Added to Cart",
  //     content: `${product.name} has been added to your cart.`,
  //     okText: "Continue Shopping",
  //     onOk: () => handleClose(),
  //   });
  // };

  return (
    <div id="HomeScreen">
      <div className="container">
        <Navbar />
        <>
          {/* <div id="searchSection">
            <Title level={4}>Product Purchase</Title>
            <div style={{ width: "100%", marginBottom: 10 }}>
              <div style={{ marginBottom: 5 }}>Restaurant</div>
              <Button
                onClick={() => {
                  setRestaurantListModalVisible(true);
                }}
                size="large"
                style={{ width: "100%", textAlign: "left" }}
              >
                {selectedRestaurant?.name
                  ? selectedRestaurant?.name
                  : "Please select restaurant"}
              </Button>
            </div>

            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                className="buttonSearch"
                loading={searching}
                disabled={!selectedRestaurant}
                style={{
                  width: "100%",
                  backgroundColor: "#e90056",
                  borderColor: "#e90056",
                }}
                size="large"
                type="primary"
                onClick={onSearch}
              >
                <SearchOutlined
                  onPointerEnterCapture={undefined}
                  onPointerLeaveCapture={undefined}
                />
                Search Products
              </Button>
            </div>
          </div> */}
          <div className="productListWrapper">
            <div>
              <Title level={4}>Available Products</Title>
              {/* {products.length === 0 && !searching && (
                <Text type="secondary">
                  {selectedRestaurant
                    ? "No products found for this restaurant. Please try another restaurant."
                    : "Please select a restaurant to view products."}
                </Text>
              )} */}
            </div>
            <Divider />
            <List
              grid={{
                gutter: 16,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3, // Add this for very large screens
              }}
              dataSource={products}
              renderItem={(product: any) => {
                const productVariants = getProductVariants(product);
                const hasVariants = productVariants.length > 1;

                return (
                  <List.Item>
                    <Card
                      hoverable
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        height: "100%", // Use full height available in grid
                        width: "100%",
                      }}
                      bodyStyle={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        padding: "16px",
                      }}
                      cover={
                        <div
                          style={{
                            width: "100%",
                            aspectRatio: "1 / 1", // Maintain 1:1 aspect ratio
                            overflow: "hidden",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#f5f5f5",
                          }}
                        >
                          <img
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              objectPosition: "center",
                            }}
                            src={product.image_url}
                            alt={product.name}
                            onError={(e) => {
                              e.currentTarget.src = "/placeholder-image.png";
                            }}
                          />
                        </div>
                      }
                      onClick={() => {
                        navigateWithReferral(`${product.product_id}`);
                      }}
                      actions={[
                        <Button
                          type="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigateWithReferral(`${product.product_id}`);
                          }}
                        >
                          {hasVariants ? "View Options" : "Add to Cart"}
                        </Button>,
                      ]}
                    >
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Card.Meta
                          title={
                            <div
                              style={{
                                fontSize: "16px",
                                fontWeight: "bold",
                                lineHeight: "1.3",
                                minHeight: "30px", // Minimum height for title
                                maxHeight: "30px", // Maximum height for title
                                overflow: "hidden",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {product.name}
                            </div>
                          }
                          description={
                            <div
                              style={{
                                flex: 1,
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#666",
                                  lineHeight: "1.4",
                                  minHeight: "34px", // Minimum height for description
                                  maxHeight: "34px", // Maximum height for description
                                  overflow: "hidden",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  marginBottom: "12px",
                                }}
                                dangerouslySetInnerHTML={{
                                  __html: truncate(
                                    product.desc.replace(/<[^>]+>/g, ""),
                                    80
                                  ),
                                }}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  flexWrap: "wrap",
                                  alignItems: "center",
                                  gap: 8,
                                  marginTop: "auto", // Push to bottom
                                }}
                              >
                                <Tag color="green">RM {product.price}</Tag>
                                {product.app_promotion_price &&
                                  product.app_promotion_price !== "0.00" && (
                                    <Tag color="red">
                                      Promo: RM {product.app_promotion_price}
                                    </Tag>
                                  )}
                              </div>
                            </div>
                          }
                        />
                      </div>
                    </Card>
                  </List.Item>
                );
              }}
            />
          </div>
          {/* @ts-ignore */}
          <Modal
            title="Restaurant List"
            visible={restaurantListModalVisible}
            footer={null}
            onCancel={() => setRestaurantListModalVisible(false)}
          >
            <List
              itemLayout="horizontal"
              dataSource={restaurants}
              renderItem={(rest: any) => (
                <List.Item
                  onClick={() => {
                    if (rest.status === "0") {
                      alert(
                        "Restaurant is closed. Please try again or select another option. Thank you!"
                      );
                      return;
                    }
                    onSelectRestaurant(rest);
                    setRestaurantListModalVisible(false);
                  }}
                  style={{
                    cursor: "pointer",
                    borderBottom: "1px solid #f0f0f0",
                    padding: "12px 0",
                  }}
                >
                  <List.Item.Meta
                    avatar={
                      <Avatar
                        shape="square"
                        size={64}
                        src={rest.logo_url || rest.images}
                      />
                    }
                    title={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 8,
                        }}
                      >
                        <span>{rest.name}</span>
                        {renderStatus(rest.status)}
                      </div>
                    }
                    description={
                      <div>
                        <div>{rest.address}</div>
                        <div>{rest.phone_number}</div>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </Modal>
        </>
        <Footer />
      </div>
    </div>
  );
});

export default ProductList;
